import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  inProgressReturnLabel: {
    id: 'VqcSGS',
    defaultMessage: 'Return (New)',
    description: 'New in-progress return info persisted till the order details drawer is open.',
  },
});
